var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "income",
        style: { "--bacg": _vm.bacg, "--border": _vm.border },
      },
      [
        _c("div", { staticClass: "leftLine1" }, [
          _c("p", { staticClass: "p1" }, [_vm._v("订单状态")]),
          _c("div", { staticClass: "line" }),
          _c("div", { staticClass: "rightBox" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "select1",
                    staticStyle: { width: "2.1rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "请选择" },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  _vm._l(_vm.options, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btns1",
                    class: _vm.current === "已经关闭订单" ? "active" : "",
                    attrs: { size: "small", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.current = "已经关闭订单"
                      },
                    },
                  },
                  [_vm._v("已经关闭订单")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "center" },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("订单状态")]),
                _c("div", { staticClass: "line" }),
                _c(
                  "el-button",
                  {
                    staticClass: "btns1",
                    class: _vm.current1 === "已入账" ? "active" : "",
                    staticStyle: { "margin-right": "0.1rem" },
                    attrs: { size: "small", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.current1 = "已入账"
                      },
                    },
                  },
                  [_vm._v("已经关闭订单")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btns1",
                    class: _vm.current1 === "待入账" ? "active" : "",
                    attrs: { size: "small", plain: "" },
                    on: {
                      click: function ($event) {
                        _vm.current1 = "待入账"
                      },
                    },
                  },
                  [_vm._v("已经关闭订单")]
                ),
              ],
              1
            ),
            _vm._m(0),
          ]),
        ]),
        _c("div", { staticClass: "leftLine1" }, [
          _c("p", { staticClass: "p1" }, [_vm._v("查询结果")]),
          _c("div", { staticClass: "line", staticStyle: { height: "1rem" } }),
          _c("div", { staticClass: "rightBox1" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "0.2rem",
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "select1",
                    staticStyle: { width: "1.4rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "请选择" },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  _vm._l(_vm.options1, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "订单编号" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "团号" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "C端达人" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "新客" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "用户名称" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "下单企业名称" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "下单用户账号" },
                }),
                _c("el-input", {
                  staticStyle: { width: "1rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "分销账号" },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "select1",
                    staticStyle: { width: "1.2rem", "margin-right": "0.1rem" },
                    attrs: { size: "small", placeholder: "支付方式" },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  _vm._l(_vm.options2, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  overflow: "hidden",
                },
              },
              [
                _c("el-input", {
                  staticStyle: { width: "1.4rem", "margin-right": "0.1rem" },
                  attrs: { size: "small", placeholder: "支付交易单号" },
                }),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.1rem", width: "140px" },
                  attrs: {
                    size: "small",
                    type: "date",
                    placeholder: "选择下单日期",
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                }),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.1rem", width: "140px" },
                  attrs: {
                    size: "small",
                    type: "date",
                    placeholder: "选择付款日期",
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                }),
                _c("p", [_vm._v("金额：")]),
                _c(
                  "el-radio-group",
                  [
                    _c(
                      "el-radio",
                      { attrs: { label: 3 } },
                      [
                        _c("span", { staticStyle: { "margin-right": "5px" } }, [
                          _vm._v("大于等于"),
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "1rem", "margin-right": "5px" },
                          attrs: { size: "small", placeholder: "请输金额" },
                        }),
                        _c("span", [_vm._v("¥")]),
                      ],
                      1
                    ),
                    _c(
                      "el-radio",
                      { attrs: { label: 9 } },
                      [
                        _c("span", { staticStyle: { "margin-right": "5px" } }, [
                          _vm._v("小于等于"),
                        ]),
                        _c("el-input", {
                          staticStyle: { width: "1rem", "margin-right": "5px" },
                          attrs: { size: "small", placeholder: "请输金额" },
                        }),
                        _c("span", [_vm._v("¥")]),
                      ],
                      1
                    ),
                    _c(
                      "el-radio",
                      { attrs: { label: 6 } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "1rem", "margin-right": "5px" },
                          attrs: { size: "small", placeholder: "请输金额" },
                        }),
                        _c("span", [_vm._v("¥")]),
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "0.1rem" } },
                          [_vm._v("至")]
                        ),
                        _c("el-input", {
                          staticStyle: { width: "1rem", "margin-right": "5px" },
                          attrs: { size: "small", placeholder: "请输金额" },
                        }),
                        _c("span", [_vm._v("¥")]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
    _c(
      "footer",
      { staticClass: "footer" },
      [
        _vm._m(1),
        _c(
          "div",
          { staticStyle: { border: "1px solid #ebeef5" } },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": {
                    backgroundColor: "#FDEFE7",
                    color: "#000000",
                  },
                  data: _vm.tableData,
                  "tooltip-effect": "dark",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    fixed: "left",
                    width: "150",
                    prop: "orderChildrenId",
                    align: "center",
                    label: "订单编号",
                  },
                }),
                _c("el-table-column", {
                  attrs: { width: "150", align: "center", label: "下单时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormatHms")(
                                  scope.row.orderCreateTime
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "customType",
                    align: "center",
                    width: "200",
                    label: "下单用户类型",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "nameOfSuperiorCustomer",
                    align: "center",
                    width: "190",
                    label: "下单账号昵称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "orderStatusStr",
                    align: "center",
                    label: "订单状态",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "商品金额" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.orderPrice) +
                              _vm._s(scope.row.currency) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", width: "200", label: "预计利润" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.estimatedProfit) +
                              _vm._s(scope.row.currency) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "实际利润" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.actualProfit) +
                              _vm._s(scope.row.currency) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("Pagination", {
          attrs: {
            currentPage: _vm.init.page,
            pageSizes: _vm.pageSizes,
            parentPageSize: 10,
            totalNumber: _vm.AllpagesNum,
          },
          on: { loadTable: _vm.loadTable },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "right" }, [
      _c("p", [_vm._v("符合条件共：")]),
      _c("div", { staticClass: "rightBlock" }, [
        _c("p", [_vm._v("0")]),
        _c("p", [_vm._v("订单")]),
      ]),
      _c("div", { staticClass: "rightBlock" }, [
        _c("p", [_vm._v("0")]),
        _c("p", [_vm._v("订单")]),
      ]),
      _c("div", { staticClass: "rightBlock" }, [
        _c("p", [_vm._v("0¥")]),
        _c("p", [_vm._v("订单")]),
      ]),
      _c("p", { staticClass: "p3" }, [_vm._v("清空筛选条件")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footTitle" }, [
      _c("div", { staticClass: "footTitleLeft" }, [
        _c("p", { staticClass: "p1" }, [
          _vm._v("客户下单及利润列表（我的佣金）"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }